import request from "../request";

/**
 * 获取党支部领导班子架构
 * @param {*} data
 */
export function getcommitteememberapi(data) {
  return request.get('/admin/screen/get_member_division', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 获取行政领导班子
 * @param {*} data
 */
export function getleadershipsapi(data) {
  return request.get('/admin/screen_public/get_leaderships', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 获取团队架构
 * @param {*} data
 */
export function getteamframeworkapi(data) {
  return request.get('/admin/screen_public/get_team_framework', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 获取团队下人员信息统计
 * @param {*} data
 */
export function getteamcensusapi(data) {
  return request.get('/admin/screen_public/get_team_census', data, {
    passerr: false,
    isauth: true
  })
}


/**
 * 获取党组织下人员信息统计
 * @param {*} data
 */
export function getpartymembercensusapi(data) {
  return request.get('/admin/screen_public/get_party_member_census', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 发布内容(1发展历程，2典型案例，3荣誉展示，4党员示范岗，5巾帼示范岗，6.党建风采，7.特色亮点)
 * @param {*} data
 */
export function addbasicinformationapi(data) {
  return request.post('/admin/screen_public/add_basic_information', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 修改内容(1发展历程，2典型案例，3荣誉展示，4党员示范岗，5巾帼示范岗，6.党建风采，7.特色亮点)
 * @param {*} data
 */
export function editbasicinformationapi(data) {
  return request.post('/admin/screen_public/edit_basic_information', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 设置组织/公司创始人
 * @param {*} data
 */
export function setfounderapi(data) {
  return request.post('/admin/screen_public/set_founder', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 获取组织/公司创始人
 * @param {*} data
 */
export function getfounderapi(data) {
  return request.get('/admin/screen_public/get_founder', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 积分排行榜
 * @param {*} data
 */
export function getintegralrankapi(data) {
  return request.get('/admin/screen/integral_rank', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 发展党员数据统计
 * @param {*} data
 */
export function developcensusapi(data) {
  return request.get('/admin/screen/develop_census', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 会议数据统计
 * @param {*} data
 */
export function meetingcensusapi(data) {
  return request.get('/admin/screen/meeting_census', data, {
    passerr: false,
    isauth: true
  })
}


/**
 * 配置数据大屏公共部分
 * @param {*} data
 */
export function edithomepageapi(data) {
  return request.post('/admin/screen_public/edit_home_page', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 获取数据大屏公共部分(改内容)
 * @param {*} data
 */
export function gethomepageapi(data) {
  return request.get('/admin/screen_public/get_home_page', data, {
    passerr: false,
    isauth: true
  })
}


/**
 * 获取数据大屏首页
 * @param {*} data
 */
export function gethomepagebysignapi(data) {
  return request.get('/admin/screen_home/get_home_page_by_sign', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 官网数据关键字
 * @param {*} params
 * @returns
 */

export function change_webData(data) {
  return request.post('/admin/screen_get_article/get_web_data', data, {
    passerr: false,
    isauth: true
  })
}
/**
 * 获取抓取文章设置（组织）
 */
export function get_web_data_set(data) {
  return request.get('/admin/screen_get_article/get_grab_set', data, {
    passerr: false,
    isauth: true
  })
}


/**
 * 互联共建配置
 * @param {*} params
 * @returns
 */

export function editCooperateapi(data) {
  return request.post('/admin/v3/setPublic', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 互联共建获取信息
 * @param {*} params
 * @returns
 */

export function getCooperateapi(data) {
  return request.post('/admin/v3/getPublic ', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 添加互联共建公司
 * @param {*} params
 * @returns
 */
export function addPublicCompany (data) {
  return request.post('/admin/v3/addPublicCompany', data, {
    passerr: false,
    isauth: true
  })
}

/**
 * 修改互联共建公司
 * @param {*} params
 * @returns
 */
export function editPublicCompany (data) {
  return request.post('/admin/v3/editPublicCompany', data, {
    passerr: false,
    isauth: true
  })
}







// WEBPACK FOOTER //
// ./src/network/api/platformghome.js